import Swal from 'sweetalert2';

export const showAlert = async ({ title, text, icon, confirmButtonText = "OK", cancelButtonText = "Cancel", showCancelButton = false }) => {
  return await Swal.fire({
    title,
    text,
    icon,
    showCancelButton,
    confirmButtonText,
    cancelButtonText,
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
};
